import Vue from "vue";

export class ServerInterface {
    constructor(sandbox) {
        this.sandbox = sandbox;
        this.sandboxPrefix = sandbox === 1 ? "/sandbox" : "";
    }

    get(path, params) {
        let realPath = this.sandboxPrefix + path;
        return new Promise((resolve, reject) => {
            Vue.prototype.$axios.get(realPath, params)
                .then(res => resolve(res))
                .catch(ex => reject(ex));
        });
    }

    post(path, params) {
        let realPath = this.sandboxPrefix + path;
        return new Promise((resolve, reject) => {
            Vue.prototype.$axios.post(realPath, params)
                .then(res => resolve(res))
                .catch(ex => reject(ex));
        });
    }
}



// WEBPACK FOOTER //
// ./src/axios/ServerInterface.js